"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCustomStyles = void 0;
var _useTheme = _interopRequireDefault(require("@material-ui/core/styles/useTheme"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var getCustomStyles = (padding, paddingX, paddingY) => {
  var theme = (0, _useTheme.default)();
  var customStyles = {};
  if (padding !== undefined) customStyles.padding = theme.spacing(padding);
  if (paddingX !== undefined) {
    var paddingValue = theme.spacing(paddingX);
    customStyles.paddingLeft = paddingValue;
    customStyles.paddingRight = paddingValue;
  }
  if (paddingY !== undefined) {
    var _paddingValue = theme.spacing(paddingY);
    customStyles.paddingTop = _paddingValue;
    customStyles.paddingBottom = _paddingValue;
  }
  return customStyles;
};
exports.getCustomStyles = getCustomStyles;